import React, {useCallback} from 'react';
import {useTranslation} from 'react-i18next';
import EditorLayout from '../../../../components/Layouts/EditorLayout';
import SMCTextInput from '../../../../components/Simple/SMCTextInput';
import {ImageGetSchema} from '../../../../api/DBSchema/Image';
import SMCTextArea from '../../../../components/Simple/SMCTextArea';

const pageSchema = ImageGetSchema.pages.general;
const pageId = pageSchema.pageId;

function ImageGeneral({
    imageObject,
    setImageData
}) {
    const { t } = useTranslation();

    const pageData = imageObject[pageId];
    const setPageValue = useCallback((paramName, value) => {
        setImageData([pageId, paramName], value);
    }, [setImageData]);

    const comment            = pageData[pageSchema.comment];
    const displayDescription = pageData[pageSchema.displayDescription];
    const reportPath         = pageData[pageSchema.reportPath];

    return (
        <EditorLayout>
            <SMCTextInput
                value={comment}
                onChange={e => setPageValue(pageSchema.comment, e.target.value)}
                label={t('SMC_GUI_COMMENT')}
            />
            <SMCTextArea
                value={displayDescription}
                onChange={e => setPageValue(pageSchema.displayDescription, e.target.value)}
                label={t('SMC_GUI_DISPLAYDESCRIPTION')}
            />
            <SMCTextInput
                readOnly
                value={reportPath}
                label={t('SMP.ADVANCED.USAGE_IN_REPORTS')}
            />
        </EditorLayout>
    )
}

export default ImageGeneral;